import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { Form, FormInputText, FormInputDropdown, FormAutoCompleteDropdownCard, InputDropdown, FormCheckRadioInput } from "../Form";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { StandardConst } from "../../Services/StandardConst";
import _ from "underscore";
import { SignalCellularNullSharp } from "@mui/icons-material";
import { WSSuccessAlert } from "../../Services/WSAlert";

const { forwardRef, useState, useImperativeHandle } = React;
const AddEditShiftTiming = (prop, ref) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [data, setData] = useState({ Permission: {} });
  const [locationData,setlocationData]=useState([])
  const companyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
  
  const Roles = useSelector((s) => s.auth.AssignRole ?? {});
  useImperativeHandle(ref, () => ({
    openModal: async (id) => {
      getsetlocation();
      const data = await WebService({
        endPoint: `CommonUtility/Edit/ShiftTiming?WorkShiftId=${id || 0}`,
        dispatch,
      });
     
    
      setData(data[0]);
      setShow(true);
    },
  }));

  const handleClose = () => setShow(false);
  const requiredMessage = "This is a required field";

  
  const schema = yup.object().shape({
    ShiftName: yup.string().trim().required(requiredMessage),
    FromTime: yup.string().required(requiredMessage),
    ToTime: yup.string().required(requiredMessage),
  
    OfficeLocationId: yup.string().required(requiredMessage),
  
    AllowOverTime: yup.string().required(requiredMessage),
    AutoCheckout: yup.string().required(requiredMessage),
  
    ShiftApplicableStartDate: yup
      .date()
      .required(requiredMessage)
      .typeError('Invalid start date'),
  
    ShiftApplicableEndDate: yup
      .date()
      .required(requiredMessage)
      .typeError('Invalid end date')
      .min(yup.ref('ShiftApplicableStartDate'), 'End date cannot be before start date'),
  });
  


   const fetchEmployeeList = () => {
      WebService({
        endPoint: `Visitor/fetchAllEmployees`,
        dispatch
      })
        .then((result) => {
          const empDDOpt = _.map(result, (m) => {
            return {
              EmployeeId: m.EmployeeId,
              heading: m.FullName,
              description: m.Designation,
              avatar: `${StandardConst.apiBaseUrl}/uploads/${m.ProfileImage}`
            };
          });
          // setElpList(empDDOpt);
      });

     WebService({
                  endPoint: `CommonUtility/fetchAll/users?CompanyId=${companyInfo.CompanyId || 0}`,
                  dispatch,
              }).then((result)=>{
                 const userslist = result?.filter((r) => r.FullName !== null)?.map((res) => {
                            return {
                                UserId: res.UserId,
                                heading: res.FullName,
                                description: res.Designation,
                                avatar: `${StandardConst.apiBaseUrl}/uploads/${res.ProfileImage}`
                            }
                        });
                  //  setUserList(userslist)
              })

    };
     const getsetlocation = () => {
        WebService({
          endPoint: `UserProfile/Fetchlocation`,
          dispatch,
        }).then((data) => {
          setlocationData(
            data.data.map((v) => {
              const words = v.Address.split(' ');
              const truncatedWords = words.slice(0, 3);
              const truncatedAddress = truncatedWords.join(' ');
              const finalAddress = truncatedAddress + ', ' + v.Location;
              return {
                value: v.OfficeLocationId,
                text: finalAddress,
              };
            })
          );
        });
      };
  const onSubmit = async (data) => {

    data.CompanyId=companyInfo.CompanyId

    if (data.WorkShiftId === undefined) {
      await WebService({
        endPoint: "CommonUtility/ShiftTiming",
        body: data,
        dispatch,
      });
      WSSuccessAlert(
                "Success",
                `Shift Added successfully.`
              );
    } else {
      await WebService({
        endPoint: `CommonUtility/ShiftTiming?WorkShiftId=${data.WorkShiftId}`,
        method: "PUT",
        body: data,
        dispatch,
      });
      WSSuccessAlert(
                "Success",
                `Shift updated successfully.`
              );
    }
    handleClose();
    prop.callBackEvent();
  };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {(data?.WorkShiftId || 0) === 0
            ? "Add Work Shift"
            : "Edit Work Shift"}
        </Modal.Title>
      </Modal.Header>
      <Form
        defaultValues={data}
        onSubmit={onSubmit}
        // validationSchema={schema}
      >
        <Modal.Body className="p-4">
          <div className="row">
            <div className="col-md-12">
              <FormInputDropdown
                ddOpt={locationData}
                name="OfficeLocationId"
                label='Office Location'
                isRequired={true}
              />
            </div>
            <div className="col-md-12">
              <FormInputText
                label="Give a name to your shift"
                name="ShiftName"
                type="text"
                className="form-control"
                isRequired="true"
              />
            </div>
            <div className="col-md-12">
            <FormInputText
                label="Shift starts at"
                name="FromTime"
                type="time"
                className="form-control"
                isRequired="true"
              />
            </div>
             
              <div className="col-md-12">
              <FormInputText
                label="Shift ends at"
                name="ToTime"
                type="time"
                className="form-control"
                isRequired="true"
              />
            </div>
            
         
           
            <div className="col-md-12">
              <FormInputText
                name="ShiftApplicableStartDate"
                label="Shift Applicable Start Date"
                className="form-control"
                type="date"
              />
            </div>
            <div className="col-md-12">
              <FormInputText
                name="ShiftApplicableEndDate"
                label="Shift Applicable EndDate"
                className="form-control"
                type='date'
              />
            </div>
            <div className="col-md-12">
              <FormCheckRadioInput
                name="AllowOverTime"
                label="Allow Over Time"
                ddOpt={StandardConst.YesOrNo}
                isRadio
              />
            </div>
            <div className="col-md-12">
              <FormCheckRadioInput
                name="AutoCheckout"
                label="Auto Check out"
                ddOpt={StandardConst.YesOrNo}
                isRadio              
              />
            </div>
          
          </div>
        </Modal.Body>
        <Modal.Footer>          
          <Button  id="btnPermissionSubmit" variant="outline-primary" type="submit">  {(data?.WorkShiftId || 0) === 0
                ? "Save Shift Details"
                : "Save Changes"}</Button>
        </Modal.Footer>  
      </Form>
    </Modal>
  );
};

export default forwardRef(AddEditShiftTiming);




